<script lang="ts" setup generic="T extends any">
import { computed } from '#imports';

type Props = {
    data: T[] | undefined;
    isLoading?: boolean;
    loaderSize: number;
    isError: boolean;
    changeGrid?: boolean;
};

const props = defineProps<Props>();

defineOptions({
    inheritAttrs: false
});

const gridStyle = computed(() => {
    const amount = props.data?.length || 1;
    const cardSize = props.changeGrid
        ? '121px'
        : '182px';
    if (amount <= 4 && !props.isLoading) return `grid-template-columns: repeat(4, minmax(${cardSize}, 1fr));`;
    return `grid-template-columns: repeat(auto-fit, minmax(${cardSize}, 1fr));`;
});

</script>

<template>
  <Transition name="fade"
              mode="out-in"
  >
    <div v-if="isLoading && !isError"
         class="layout-card-container"
         :style="gridStyle"
         v-bind="$attrs"
    >
      <slot v-for="(_, index) in Array.from({ length: loaderSize })"
            :key="index"
            name="loader"
      ></slot>
    </div>
    <div v-else-if="data && data.length"
         class="layout-card-container"
         :style="gridStyle"
         v-bind="$attrs"
    >
      <slot v-for="(item, index) in data"
            name="cart"
            :item="item"
            :index="index"
      ></slot>
    </div>
    <slot v-else-if="data && !data.length"
          name="empty"
    ></slot>
    <slot v-else-if="isError || (isLoading && isError)"
          name="error"
    ></slot>
  </Transition>
</template>

<style lang="scss">

.layout-card {
  &-container {
    display: grid;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;

    @include desktop-1200 {
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }

    @include tablet-1024 {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }

    @include tablet-768 {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    @include mobile-576 {
      grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
